<template>
  <div :class="['nav navbar navbar-static-top white-bg py-2']">
    <Button
      v-if="showMenu"
      :severity="ButtonTypes.Secondary"
      :icon="Icons.Bars"
      class="navbar-minimalize hamburger-button"
      raised />
    <div v-else></div>
    <NavBarVenueComponent></NavBarVenueComponent>
    <NavBarIconMenuComponent></NavBarIconMenuComponent>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { ButtonTypes } from '@/enums/components.enum'
import NavBarVenueComponent from '@/components/NavBar/NavBarVenueComponent.vue'
import NavBarIconMenuComponent from '@/components/NavBar/NavBarIconMenuComponent.vue'
import Button from '@/components/Tailwind/Button/Button.vue'
import { Icons } from '@/components/Tailwind/Icons/types'

export default defineComponent({
  components: { NavBarVenueComponent, NavBarIconMenuComponent, Button },
  name: 'NavBar Component',
  props: {
    showMenu: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    return {
      ButtonTypes,
      Icons
    }
  }
})
</script>
<style scoped>
.hidden {
  display: none;
}

.hamburger-button {
  width: 1.75rem !important;
  min-width: 1.75rem !important;
  max-width: 1.75rem !important;
  height: 1.75rem;
}
</style>
